import { Col, Row } from 'antd';
import React from 'react';
import SkeletonCustom from './SkeletonCustom';

const StrategicHighlightsSkeleton = function StrategicHighlightsSkeleton() {
  return (
    <>
      <Row className="pills-one-liner">
        <Col span={24}>
          <SkeletonCustom height="180px" width="100%" />
        </Col>
      </Row>
    </>
  );
};

export default StrategicHighlightsSkeleton;
